import { useTractionDescQuery } from "../generated/graphql";

export function TractionValue(props: { val: string }) {
  const [{ data }] = useTractionDescQuery({ variables: { kind: props.val } });
  return <>{data?.tractions_by_pk?.description}</>;
}
